import { render, staticRenderFns } from "./CustomerUpdate.vue?vue&type=template&id=ce5c841a&scoped=true&"
import script from "./CustomerUpdate.vue?vue&type=script&lang=js&"
export * from "./CustomerUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5c841a",
  null
  
)

export default component.exports